import {
  MONTHLY_TERM,
  PACKAGE_CARD_DESCRIPTIONS,
  PACKAGE_CARD_IS_POPULAR,
  PACKAGE_CARD_SUBHEADERS,
  PACKAGE_HIGHLIGHTS,
  PACKAGE_TITLES,
} from './constants';

export const getBundleCardProps = (bundleName) => ({
  bundleName,
  description: PACKAGE_CARD_DESCRIPTIONS[bundleName],
  header: PACKAGE_TITLES[bundleName],
  highlights: PACKAGE_HIGHLIGHTS[bundleName],
  popularText: PACKAGE_CARD_IS_POPULAR[bundleName] && 'Most popular',
  subHeader: PACKAGE_CARD_SUBHEADERS[bundleName],
});

export const handleOnToggleFeatureList = (
  plan,
  trackEvent,
  trackEventPath = ''
) => {
  if (!trackEvent) {
    return;
  }

  const trackEventPathEnd = plan
    ? 'seeEachCardFeaturesOpened'
    : 'seeAllFeaturesOpened';
  const trackEventFullPath = `${trackEventPath}.${trackEventPathEnd}`;
  const trackEventOptions = plan ? { plan } : {};

  trackEvent(trackEventFullPath, trackEventOptions);
};

export const getBundlePrices = ({
  allPrices = [],
  bundlePlan,
  term = MONTHLY_TERM,
} = {}) =>
  allPrices?.find(
    (bundlePrice = {}) =>
      bundlePrice.bundleSlug === bundlePlan && bundlePrice.term === term
  );
